import React, { memo } from 'react';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';
import { useNavigate, useLocation } from 'react-router-dom';

import { selectLoggedIn } from '@containers/App/state/selectors';
import { useAppSelector } from '@app/hooks';
import MultiButtonRow from '@components/MultiButtonRow';
import { COLORS, FONT_SIZE, FONTS, PADDING } from '@constants/styles';
import { NAV_OPTIONS } from '@constants/constants';
import RowItem from './components/RowItem';

// import SocialMedia from '../SocialMedia';

const ST = {
  Wrapper: styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${COLORS.WHITE};
  `,
  Header: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 10px;
    flex-direction: row;
    align-items: center;
  `,
  HeaderText: styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
    color: ${COLORS.BLACK};
    font-size: ${FONT_SIZE.PX24};
    font-family: ${FONTS.SUPER_BOLD};
  `,
  CloseButton: styled.div`
    cursor: pointer;
  `,
  LoginButton: styled.div`
    height: 70px;
    width: 100%;
    padding: 0px ${PADDING.MD};
  `,
};

interface Props {
  closeDrawer: () => void;
}

const Drawer: React.FC<Props> = ({ closeDrawer }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const loggedIn = useAppSelector(selectLoggedIn);

  const navTo = (path: string) => {
    navigate(path);
  };

  const goToLogin = () => {
    navTo('/auth/login');
  };

  return (
    <ST.Wrapper>
      <ST.Header>
        <ST.HeaderText>PERC Pro</ST.HeaderText>
        <ST.CloseButton onClick={closeDrawer}>
          <MdClose color={COLORS.TEXT} size={20} />
        </ST.CloseButton>
      </ST.Header>
      {NAV_OPTIONS.map(d => (
        <RowItem
          key={d.label}
          label={d.label}
          clickFcn={() => {
            closeDrawer();
            navTo(d.path);
          }}
          height={'70px'}
          highlight={
            d.path === location.pathname ||
            d.alternatePaths.includes(location.pathname)
          }
        />
      ))}

      {loggedIn ? (
        <RowItem
          label={'My Profiles'}
          clickFcn={() => {
            closeDrawer();
            navTo('/account');
          }}
          height={'70px'}
          highlight={['/user', '/account'].includes(location.pathname)}
        />
      ) : (
        <ST.LoginButton>
          <MultiButtonRow
            buttons={[
              {
                key: 'login',
                text: 'Login',
                fcn: goToLogin,
                style: 'MAIN',
              },
            ]}
          />
        </ST.LoginButton>
      )}
    </ST.Wrapper>
  );
};

export default memo(Drawer);
